import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=2bed22a6&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=2bed22a6&prod&scoped=true&lang=css"
import style1 from "./Layout.vue?vue&type=style&index=1&id=2bed22a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed22a6",
  null
  
)

export default component.exports